import PrimaryButton from "../../../../../../sharedComponents/primaryButton/PrimaryButton";
import "./EmployeeCreationAbsence.css";
import { Button, ButtonGroup, Checkbox, Divider, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Snackbar, Alert } from "@mui/material";
import { Modal } from "react-bootstrap";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from '@mui/icons-material/Add';
import CancelButton from "../../../../../../sharedComponents/cancelButton/CancelButton";
import { useEffect, useState } from "react";
import axios from "axios";
import { Calendar } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { DatePicker } from "rsuite";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import Fab from '@mui/material/Fab';

const weekDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]

function EmployeeCreationAbsence(props) {

    const [openModal, setOpenModal] = useState(false);

    const [selectedTab, setSelectedTab] = useState(0);

    const [absencesDates, setAbsencesDates] = useState(null);

    const [doubleAbsenceError, setDoubleAbsenceError] = useState(false);
    

    const changeTab = () => {
        setAddingNoInputError(false);
        setAddingAbsenceError(false);
        if (selectedTab === 0) {
            setSelectedTab(1);
        } else {
            setSelectedTab(0);
        }
    }

    const [selectedYearMonth, setSelectedYearMonth] = useState(new Date());
    const [countDays, setCountDays] = useState(1);
    const [countHours, setCountHours] = useState(8);
    const [requestParameterHourMinute, setRequestParameterHourMinute] = useState({});
    const [paidCheckbox, setPaidCheckbox] = useState(true);
    const [vacationOrIllness, setVacationOrIllness] = useState("vacation"); 
    const [comment, setComment] = useState("");
    const [addingAbsenceError, setAddingAbsenceError] = useState(false);
    const [addingNoInputError, setAddingNoInputError] = useState(false);

    const [createAbsenceDays, setCreateAbsenceDays] = useState([]);

    const [values, setValues] = useState([]);
    const [doubledAbsence, setDoubledAbsence] = useState([]);

    useEffect(() => {
        setAbsencesDates(props.absences?.map(absence => absence.absence_days.map(days => days.date)).flat());
    }, [props.absences])

    const handleClose = () => {
        setAddingAbsenceError(false);
        setOpenModal(false);
    }

    const handleAddClick = () => {
        setOpenModal(true);
        setCountDays(1);
        setCountHours(8);
        setRequestParameterHourMinute({hour: 8, minute: 0})
        setPaidCheckbox(true);
        setVacationOrIllness("vacation");
        setComment("");
        setCreateAbsenceDays([]);
        setValues([]);
        setSelectedYearMonth(new Date());
        setAddingNoInputError(false);
        setSelectedTab(0);
    }

    const handleDayChange = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setCountDays(Math.max(Number(e.target.value), 1));
        }        
    }
    
    const handleHourChange = (e) => {
        const regex = /^\d*,?\d{0,2}$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setCountHours(e.target.value);

            let valueArray = e.target.value.split(",");
            let timeObject;
            if(valueArray.length === 1 || valueArray[1] === ""){
                timeObject = {hour: valueArray[0], minute: 0};
                setRequestParameterHourMinute(timeObject);    
            } else {
                timeObject = {hour: valueArray[0], minute: Math.round((parseInt(valueArray[1])/Math.pow(10, valueArray[1].length))*60)};
                setRequestParameterHourMinute(timeObject);
            }
        }
    }

    const handleVacationSelect = (event) => {
        setVacationOrIllness(event.target.value);
    }

    const handleCheckbox = (event) => {
        setPaidCheckbox(event.target.checked)
    }

    const handleAddVacation = () => {
        setCreateAbsenceDays([]);
        if (selectedTab === 0) {
            prepareTerminatedAbsenceDays();
            sendTerminatedPostRequest();
        } else {
            for(let i = 0; i < countDays; i++)
                fillAbsenceDaysArray(selectedYearMonth.getFullYear().toString(), (selectedYearMonth.getMonth()+1).toString().padStart(2, '0'), "01", false);
            sendNonTerminatedPostRequest();
        }
    }

    // Returns the number of different months for monthly post requests
    function prepareTerminatedAbsenceDays() {
        values.forEach((value) => {
            const date = new Date(value);
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10)
                month = "0" + month;
            if (day < 10)
                day = "0" + day;
            fillAbsenceDaysArray(year, month, day, true);
        })
    }

    function fillAbsenceDaysArray(year, month, day, isTerminatedAbsensce) {
        createAbsenceDays.push({
            "date": year + "-" + month + "-" + day,
            "duration": "PT"+ requestParameterHourMinute.hour + "H" + requestParameterHourMinute.minute + "M",
            "ignore_specific_date": !isTerminatedAbsensce
        })
    }

    function sendTerminatedPostRequest() {
        setDoubledAbsence([]);
        // Group array after months
        const groupedAbsences = {};
        createAbsenceDays.forEach(absence => {
            const monthYear = absence.date.substring(0, 7); // Extrahiere Jahr und Monat (z.B. "2024-02")
            if (!groupedAbsences[monthYear]) {
                groupedAbsences[monthYear] = [];
            }
            groupedAbsences[monthYear].push(absence);
        })

        let newDoubledAbsence = new Set();
        
        Object.values(groupedAbsences).forEach(absenceMonth => {
            absenceMonth.forEach(absence => {
                if(absencesDates?.includes(absence.date)){
                    newDoubledAbsence.add(absence.date);
                }
            })
        })

        if (newDoubledAbsence.size > 0) {
            setDoubleAbsenceError(true);
            setDoubledAbsence(Array.from(newDoubledAbsence));
            return;
        }

        // For every month = One post request
        const promises = Object.keys(groupedAbsences).map(monthYear => {
            const absencesInMonth = groupedAbsences[monthYear];
            return axios.post('absence/createNewDatedAbsencePeriod', {
                "employee_id": new URLSearchParams(window.location.search).get("employeeId"),
                "absence_type": vacationOrIllness,
                "paid": paidCheckbox,
                "comment": comment,
                "absence_days": absencesInMonth
            })
        })

        if (promises.length === 0) {
            setAddingNoInputError(true);
        } else {
            Promise.all(promises)
                .then(() => {
                    handleClose();
                    props.setRefresh(!props.refresh)
                })
                .catch(error => {
                    setAddingAbsenceError(true);
                    setCreateAbsenceDays([]);
                })
        }
    }

    function sendNonTerminatedPostRequest() {
        axios.post('absence/createNewAbsencePeriod', {
            "employee_id": new URLSearchParams(window.location.search).get("employeeId"),
            "absence_type": vacationOrIllness,
            "paid": paidCheckbox,
            "comment": comment,
            "absence_days": createAbsenceDays
        }).then(() => {
            handleClose();
            props.setRefresh(!props.refresh)
        }).catch(() => {
            setAddingAbsenceError(true);
            setCreateAbsenceDays([]);
        })
    }

    function createModalContent() {
        if (selectedTab === 0) {
            return (
                <div className="create-absence-modal">
                    <FormControl className="vacation-select-formcontrol">
                        <InputLabel>Art der Abwesenheit</InputLabel>
                        <Select 
                            value={vacationOrIllness}
                            label="Urlaub oder Krankheit"
                            onChange={handleVacationSelect}
                            fullWidth
                        >
                            <MenuItem value={"vacation"}>Urlaub</MenuItem>
                            <MenuItem value={"illness"}>Krankheit</MenuItem>
                            <MenuItem value={"child_sick"}>Kindkrank</MenuItem>
                            <MenuItem value={"further_education"}>Weiterbildung</MenuItem>
                            <MenuItem value={"vocational_school"}>Berufsschule</MenuItem>
                            <MenuItem value={"university"}>Universität</MenuItem>
                            <MenuItem value={"school"}>Schule</MenuItem>
                            <MenuItem value={"other"}>Sonstiges</MenuItem>
                        </Select>
                    </FormControl>
                    <div className="set-hours-minutes">
                        <div className="set-buttongroup">
                            <InputLabel>Stunden pro Tag</InputLabel>
                            <ButtonGroup>
                                <TextField size="small" onChange={handleHourChange} value={countHours} sx={{width: "120px"}}/>
                            </ButtonGroup>
                            <p>Umgerechnet {requestParameterHourMinute.hour}Std {requestParameterHourMinute.minute}min</p>
                        </div>
                    </div>
                    <Divider />
                    <Calendar 
                        multiple
                        format="DD.MM.YYYY"
                        minDate={"01.01.2020"}
                        maxDate={"31.12.2300"}
                        weekDays={weekDays}
                        months={months}
                        value={values} 
                        onChange={setValues}
                        weekStartDayIndex={1}
                        plugins={[
                            <DatePanel sort="date" header="Ausgewählt"/>
                        ]}
                    />
                    <FormControlLabel control={<Checkbox checked={paidCheckbox} onChange={handleCheckbox} />} label="Mit Lohnfortzahlung" />
                    {addingNoInputError && <p className="red">Bitte wählen Sie die Tage der Abwesenheit aus.</p>}
                </div>
            )
        } else if (selectedTab === 1) {
            return (
                <div className="create-absence-modal">
                    <FormControl className="vacation-select-formcontrol">
                        <InputLabel>Art der Abwesenheit</InputLabel>
                        <Select 
                            value={vacationOrIllness}
                            label="Urlaub oder Krankheit"
                            onChange={handleVacationSelect}
                            fullWidth
                        >
                            <MenuItem value={"vacation"}>Urlaub</MenuItem>
                            <MenuItem value={"illness"}>Krankheit</MenuItem>
                            <MenuItem value={"child_sick"}>Kindkrank</MenuItem>
                            <MenuItem value={"further_education"}>Weiterbildung</MenuItem>
                            <MenuItem value={"vocational_school"}>Berufsschule</MenuItem>
                            <MenuItem value={"university"}>Universität</MenuItem>
                            <MenuItem value={"school"}>Schule</MenuItem>
                            <MenuItem value={"other"}>Sonstiges</MenuItem>
                        </Select>
                    </FormControl>
                    <DatePicker className="dashboard-datepicker"
                        cleanable={false}
                        label="Monat"
                        oneTap
                        required
                        format="MMM yyyy"
                        size="lg"
                        placeholder="Startmonat"
                        value={selectedYearMonth}
                        onSelect={(value) => setSelectedYearMonth(value)}
                    />
                    <div className="set-buttongroup">
                        <InputLabel>Anzahl der Tage</InputLabel>
                        <ButtonGroup>
                            <Button
                                onClick={() => setCountDays((prev) => prev - 1)}
                                disabled={countDays === 0}
                            >
                                <RemoveIcon fontSize="small" />
                            </Button>
                            <TextField size="small" onChange={(handleDayChange)} value={countDays} sx={{width: "60px"}}/>
                            <Button onClick={() => setCountDays((prev) => prev + 1)}>
                                <AddIcon fontSize="small" />
                            </Button>
                        </ButtonGroup>
                    </div>
                    <div className="set-hours-minutes">
                        <div className="set-buttongroup">
                            <InputLabel>Stunden pro Tag</InputLabel>
                            <ButtonGroup>
                                <TextField size="small" onChange={handleHourChange} value={countHours} sx={{width: "120px"}}/>
                            </ButtonGroup>
                            <p>Umgerechnet {requestParameterHourMinute.hour}Std {requestParameterHourMinute.minute}min</p>          
                        </div>
                    </div>
                    <FormControlLabel control={<Checkbox checked={paidCheckbox} onChange={handleCheckbox} />} label="Mit Lohnfortzahlung" />
                </div>
            )
        }
    }

    function generateCreationModal() {
        return (
            <Modal
                show={openModal}
                onHide={handleClose}
                keyboard={true}
            >
                    <Modal.Header>
                        <Modal.Title>Abwesenheit eintragen</Modal.Title>
                        <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <Tabs centered={true} onChange={changeTab} value={selectedTab} >
                                <Tab label="Terminiert" />
                                <Tab label="Nicht terminiert" />
                        </Tabs>
                        {createModalContent()}
                        {addingAbsenceError && <p className="red">Ein Fehler ist aufgetreten.</p>}                                       
                    </Modal.Body>
                    <Modal.Footer>
                        <CancelButton text="Abbrechen" onClick={handleClose} />
                        <PrimaryButton text="Abwesenheit eintragen" onClick={handleAddVacation} />
                    </Modal.Footer>
                </Modal>
        )
    }

    function createErrorSnackBar() {
        const dates = doubledAbsence.map(date => new Date(date).toLocaleDateString("de-DE", {day: "2-digit", month: "2-digit", year: "numeric"}))
        .join(", ");
        console.log(typeof dates, dates);
        
        return (
            <Snackbar open={doubleAbsenceError} autoHideDuration={6000} onClose={() => setDoubleAbsenceError(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center'}}>
                <Alert onClose={() => setDoubleAbsenceError(false)} severity="error" sx={{ width: '100%' }}>
                    Es wurde bereits eine Abwesenheit für {dates} eingetragen.
                </Alert>
            </Snackbar>
        )
    }

    return (
        <>
            <div className="absence-creation-button-container">
                <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">Abwesenheit eintragen</Tooltip>}>
                    <Fab color="primary" aria-label="add" onClick={handleAddClick} className="add-mui-icon" style={{ backgroundColor: 'var(--tictrack-secondary-color)' }}>
                        <AddIcon />
                    </Fab>
                </OverlayTrigger>
            </div>
            {generateCreationModal()}
            {doubleAbsenceError && createErrorSnackBar()}
        </>
    )
}

export default EmployeeCreationAbsence;